<template src="./Event.html"></template>

<script>
import ArrobaMedellinArrobitaNoData from "@/components/ArrobaMedellinArrobitaNoData/ArrobaMedellinArrobitaNoData";
import ArrobaMedellinLiveKitRoom from "@/components/ArrobaMedellinLiveKitRoom/ArrobaMedellinLiveKitRoom";
import EventChat from "@/components/EventChat/EventChat.vue";
import livekitService from "@/services/Livekit";
import { mapGetters } from "vuex";
import eventsService from "../../services/Events";

export default {
  name: "Event",
  components: {
    ArrobaMedellinArrobitaNoData,
    ArrobaMedellinLiveKitRoom,
    EventChat,
  },
  data() {
    return {
      role: "",
      roomName: "",
      event: {},
      showVideoText: "Activar Camara",
      showAudioText: "Activar Microfono",
      shareScreenText: "Compartir Pantalla",
      isModerator: false,
      isComponentModalActive: true,
      code: "",
      showParticipants: false,
      connectedParticipants: [],
      showChat: false,
      isRecording: false,
    };
  },
  created() {
    this.role = this.$store.state.User.user.role.name;
    this.getEvent();
  },
  methods: {
    validateModerador() {
      if (this.user.id === this.event.moderator.id) {
        this.isModerator = true;
      } else if (
        this.event.coModerator &&
        this.user.id === this.event.coModerator.id
      ) {
        this.isModerator = true;
      }
    },

    async getEvent() {
      this.event = await eventsService.getEvent(this.$route.params.idEvent);
      this.validateModerador();
      // For public events, skip the code validation modal
      if (this.event.isPublic) {
        this.createdJetsi(this.event);
      }
    },

    async validateCode(code) {
      try {
        // For public events, pass empty code
        const codeToSend = this.event.isPublic ? '' : code;
        await eventsService.validateEventCode(this.$route.params.idEvent, codeToSend);
        this.$buefy.toast.open({
          duration: 5000,
          position: "is-bottom",
          message: "Ingresando a evento!",
          type: "is-success",
        });
        this.createdJetsi(this.event);
      } catch (e) {
        this.$buefy.toast.open({
          duration: 5000,
          position: "is-bottom",
          message: e.response.data.message,
          type: "is-danger",
        });
      }
    },
    createdJetsi(event) {
      // Establecer el nombre de la sala para LiveKit
      this.roomName = event.meetUrl;
      this.$buefy.toast.open({
        duration: 5000,
        position: "is-bottom",
        message: "Ingreso a la sala con exito!",
        type: "is-success",
      });
      this.isComponentModalActive = false;
    },
    buttonShowVideo() {
      if (this.$refs.livekitRoom) {
        this.$refs.livekitRoom.handleToggleVideo();
      }
    },

    buttonShowAudio() {
      if (this.$refs.livekitRoom) {
        this.$refs.livekitRoom.handleToggleAudio();
      }
    },

    buttonShareScreen() {
      if (this.$refs.livekitRoom) {
        this.$refs.livekitRoom.handleToggleScreenShare();
      }
    },
    async finishEvent() {
      try {
        await livekitService.deleteRoom(this.roomName);
      } catch (error) {
        console.error("Error al finalizar evento:", error);
      } finally {
        if (this.$refs.livekitRoom) {
          await this.$refs.livekitRoom.handleDisconnect();
        }
        this.$router.push({ name: "Events" });
      }
    },
    closeModalValidateCode() {
      this.isComponentModalActive = false;
      if (!this.event.isPublic) {
        this.$buefy.toast.open({
          duration: 5000,
          position: "is-bottom",
          message: "Debe Ingresar el código para ver el evento",
          type: "is-danger",
        });
      }
      this.$router.push({ name: "Events" });
    },
    async toggleRecording() {
      try {
        if (!this.isRecording) {
          await livekitService.startRecording({ roomName: this.roomName });
          this.isRecording = true;
          this.$buefy.toast.open({
            duration: 3000,
            position: "is-bottom",
            message: "Grabación iniciada",
            type: "is-success",
          });
        } else {
          await livekitService.stopRecording({ roomName: this.roomName });
          this.isRecording = false;
          this.$buefy.toast.open({
            duration: 3000,
            position: "is-bottom",
            message: "Grabación detenida",
            type: "is-info",
          });
        }
      } catch (e) {
        this.$buefy.toast.open({
          duration: 5000,
          position: "is-bottom",
          message: e.response?.data?.message || "Error al cambiar grabación",
          type: "is-danger",
        });
      }
    },
    onLeaveRoom() {
      this.$router.push({ name: "Events" });
    },
    onParticipantsUpdated(participants) {
      this.connectedParticipants = participants;
    },
    toggleParticipantsPanel() {
      this.showParticipants = !this.showParticipants;
    },
    /**
     * Con pantalla compartida el asistente ve solo la presentación: aquí la
     * lista de participantes es un modal, así que basta con cerrarlo. El
     * moderador lo conserva porque necesita ver la sala mientras presenta.
     */
    onScreenShareChanged(sharing) {
      if (sharing && !this.isModerator) {
        this.showParticipants = false;
      }
    },
    toggleChat() {
      this.showChat = !this.showChat;
    },
  },

  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    roleValidationNoAccess() {
      return ["Student"].some((a) => a === this.role);
    },
    isEventPublic() {
      return this.event.isPublic || false;
    },
  },
};
</script>

<style lang="scss" src="./Event.scss" scoped></style>
